import { LoadableAfterPaint } from '@confluence/loadable';

export const ObjectSidebarContent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarContent" */ '../src/ObjectSidebarContent.tsx'
			)
		).ObjectSidebarContent,
});

// Also export the component directly for cases where lazy loading is not needed
export { ObjectSidebarContent as ObjectSidebarContentSync } from '../src/ObjectSidebarContent.tsx';
